import styled, { css } from 'styled-components'
import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import { Secondary } from 'components/Typography'
import { TextField } from 'components/Fields'
import CommonButton from 'components/Button/CommonButton'

const BOTTOM_PANEL_HEIGHT = '40px'

export const ListWLANsHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;

  @media ${theme.devices.mobile} {
    flex-direction: column;
    justify-content: space-between;
  }
`

export const WLANListTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  line-height: 32px;
  justify-content: flex-start;
  flex-grow: 3;
  @media ${theme.devices.mobile} {
    font-size: 28px;
    line-height: 40px;
  }
`

export const CreateWLANsButton = styled(CommonButton)`
  padding: 12px 16px;
  align-self: flex-end;
  @media ${theme.devices.mobile} {
    padding: 12px 32px;
  }
`

export const ConfigureRadioButton = styled(CommonButton)`
  padding: 12px 16px;
  align-self: flex-end;
  @media ${theme.devices.mobile} {
    padding: 12px 32px;
  }
`

export const WLANCreateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  @media ${theme.devices.tablet} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const NetworkWizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: calc(${BOTTOM_PANEL_HEIGHT} + ${theme.spacing.md});
`

export const NetworkWizardWhiteBlock = styled(WhiteBlock)`
  gap: 16px;
  align-items: center;
  width: 100%;
  padding: ${theme.spacing.md};
`

export const NetworkWizardJobNameBlock = styled(NetworkWizardWhiteBlock)`
  padding: ${theme.spacing.base} ${theme.spacing.md} 0 ${theme.spacing.md};
`

export const NetworkWizardErrorWrapper = styled.span`
  color: ${theme.colors.error};
`

export const NetworkWizardTextField = styled(TextField)`
  border: 1px solid ${theme.colors.pelicanGrey};
`

export const NetworkWizardSecondaryTitle = styled(Secondary)`
  color: ${theme.colors.moreGrey};
`

export const NetworkWizardWhiteBlockHeader = styled.div`
  width: 100%;
`

export const NetworkWizardWhiteBlockBody = styled.div`
  width: 100%;
  max-width: 480px;
`

export const NetworkWizardBottomPanel = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.base};
  min-height: ${BOTTOM_PANEL_HEIGHT};

  @media ${theme.devices.tablet} {
    justify-content: flex-end;
  }
`

export const NetworkWizardCancelButton = styled(CommonButton)`
  background: transparent;
  min-width: 160px;
  width: 100%;
  height: 40px;
  @media ${theme.devices.tablet} {
    width: auto;
  }
`

export const NetworkWizardSubmitButton = styled(CommonButton)`
  min-width: 160px;
  width: 100%;
  height: 40px;
  @media ${theme.devices.tablet} {
    width: auto;
  }
`

const baseFlex = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const NetworkWLANsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
`

export const NetworkWLANsHeader = styled.div`
  ${baseFlex};
  justify-content: space-between;
`

export const VisitMistButton = styled(CommonButton)`
  text-transform: capitalize;
  font-weight: 900;
  min-height: 40px;
  border-radius: 8px;
  background: transparent;
  padding: ${theme.spacing.xs} ${theme.spacing.base};
  @media ${theme.devices.tablet} {
    padding: ${theme.spacing.s} ${theme.spacing.lg};
  }
  && {
    appearance: none;
  }
`
